import InvestorInvestmentsContent from './investor-investments-content';

export default InvestorInvestmentsContent;
